import React from 'react';
import { Message } from '../types';
import AiAvatar from './AiAvatar';
import './ChatMessage.css';

interface ChatMessageProps {
  message: Message;
}

const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const isUser = message.sender === 'user';

  return (
    <div className={`message-container ${isUser ? 'user' : 'ai'}`}>
      {!isUser && <AiAvatar />}
      <div className={`message-bubble ${isUser ? 'user-bubble' : 'ai-bubble'}`}>
        <p className="message-text">{message.text}</p>
        <span className="message-time">
          {message.timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
        </span>
      </div>
    </div>
  );
};

export default ChatMessage;
